/* These all are default widgets and these components must be declared in modules entryComponent attribute */
/* This class is just for references only */
import { UpcomingtrainingsComponent } from '../upcomingtrainings/upcomingtrainings.component';
import { TimelineComponent } from '../timeline/timeline.component';
import { UpcomingeventComponent } from '../upcomingevent/upcomingevent.component';
import { MytasksComponent } from '../mytasks/mytasks.component';
import { CustomizePanelComponent } from '../customize-panel/customize-panel.component';
import { SharingPanelComponent } from '../../../shared-components/sharing-panel/sharing-panel.component';

export class Widgets {

	widgets: object|any = {};

	constructor() {
		console.log('info',"Loaded Widgets");
		this.widgets['UpcomingtrainingsComponent'] = UpcomingtrainingsComponent;
		this.widgets['UpcomingeventComponent'] = UpcomingeventComponent;
		this.widgets['MytasksComponent'] = MytasksComponent;
		this.widgets['TimelineComponent'] = TimelineComponent;
		this.widgets['CustomizePanelComponent'] = CustomizePanelComponent;
		this.widgets['SharingPanelComponent'] = SharingPanelComponent;
	}
}
